// TODO: replace with generated api-client service after client regeneration
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthControllerService } from 'src/app/api-client';
import { resolveApiBasePath } from './api-v2-base.util';

export type CompanyVerificationStatus = 'PENDING' | 'VERIFIED' | 'REJECTED';

export interface CompanyVerificationDto {
  status: CompanyVerificationStatus;
  proofUploaded: boolean;
  proofUploadedAt: string | null;
  rejectReason: string | null;
}

/**
 * Interim client for the v2 company verification endpoints.
 * Mirrors the base-path resolution of the generated api-client services.
 */
@Injectable({ providedIn: 'root' })
export class ConsoleVerificationV2Service {
  private readonly basePath: string;

  constructor(private http: HttpClient, apiConfig: AuthControllerService) {
    this.basePath = resolveApiBasePath(apiConfig);
  }

  /** Fetch the current company verification state. */
  public getVerification(): Observable<CompanyVerificationDto> {
    return this.http.get<CompanyVerificationDto>(
      `${this.basePath}/api/v2/console/verification`
    );
  }

  /** Upload a proof-of-authorization document (multipart part "proofDocument"). */
  public uploadProof(file: File): Observable<CompanyVerificationDto> {
    const formData = new FormData();
    formData.append('proofDocument', file);

    return this.http.post<CompanyVerificationDto>(
      `${this.basePath}/api/v2/console/verification/proof`,
      formData
    );
  }
}
